import { CarPolicyClaim } from './view';

export { default as CarPolicyClaimReducer } from './reducer';
export { default as CarPolicyClaimSaga } from './saga';

export default CarPolicyClaim;
